import { render, staticRenderFns } from "./videoApproveDetails.vue?vue&type=template&id=76dd2af8&scoped=true&"
import script from "./videoApproveDetails.vue?vue&type=script&lang=js&"
export * from "./videoApproveDetails.vue?vue&type=script&lang=js&"
import style0 from "./videoApproveDetails.vue?vue&type=style&index=0&id=76dd2af8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dd2af8",
  null
  
)

export default component.exports